import { TipService } from '@appStore/app/services';

export * from './tip.service';

export const services: any[] = [ TipService]